import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { SettingComponent } from './setting/setting.component';
import { DashboardAccessComponent } from './dashboard-access/dashboard-access.component';
import { LoginReportComponent } from './login-report/login-report.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { ClassTeacherAccessMapComponent } from './class-teacher-access-map/class-teacher-access-map.component';
import { RolePermisionComponent } from './role-permision/role-permision.component';
import { StaffLoginComponent } from './staff-login/staff-login.component';
import { AddRoleComponent } from './add-role/add-role.component';
import { StaffUserTypeMapComponent } from './staff-user-type-map/staff-user-type-map.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


const routes: Routes = [
  { 
    path: '', 
    component: AdminComponent,
    children: [
      { path: 'setting', component:SettingComponent, pathMatch: 'full'},
      { path: 'staffusertypemap', component:StaffUserTypeMapComponent, pathMatch: 'full'},
      { path: 'addrole', component:AddRoleComponent, pathMatch: 'full'},
      { path: 'stafflogin', component:StaffLoginComponent, pathMatch: 'full'},
      { path: 'branchadminrolepermision', component:RolePermisionComponent, pathMatch: 'full'},
      { path: 'classteacheraccessmap', component:ClassTeacherAccessMapComponent, pathMatch: 'full'},
      { path: 'studentlogin', component:StudentLoginComponent, pathMatch: 'full'},
      { path: 'loginreport', component:LoginReportComponent, pathMatch: 'full'},
      { path: 'dashboardaccess', component:DashboardAccessComponent, pathMatch: 'full'},
    
     
    ]
}
,
{
  path: '', children:[
    { path: 'changepassword', component:ChangePasswordComponent, pathMatch: 'full'},
  ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminsettingRoutingModule { }
